import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// API Base URL
const BASE_URL = "https://newalemny.3almny.app/api";

// Static files data for guest mode
const staticFiles = [
  { 
    id: 1, 
    name: "ملخص الحصة الدراسية", 
    date: "2024-01-15", 
    size: "2.5 MB", 
    subject: "الرياضيات",
    file_url: "#"
  },
  { 
    id: 2, 
    name: "تمارين تطبيقية", 
    date: "2024-01-14", 
    size: "1.8 MB", 
    subject: "العلوم",
    file_url: "#"
  },
  { 
    id: 3, 
    name: "شرح مفصل للمفاهيم", 
    date: "2024-01-13", 
    size: "3.2 MB", 
    subject: "الدراسات الاجتماعية",
    file_url: "#"
  },
  { 
    id: 4, 
    name: "اختبار تجريبي", 
    date: "2024-01-12", 
    size: "1.5 MB", 
    subject: "اللغة الإنجليزية",
    file_url: "#"
  },
  { 
    id: 5, 
    name: "ملاحظات مهمة", 
    date: "2024-01-11", 
    size: "0.8 MB", 
    subject: "الرياضيات",
    file_url: "#"
  },
  { 
    id: 6, 
    name: "شرح الفصل الأول", 
    date: "2024-01-10", 
    size: "4.1 MB", 
    subject: "العلوم",
    file_url: "#"
  },
  { 
    id: 7, 
    name: "تمارين إضافية", 
    date: "2024-01-09", 
    size: "2.2 MB", 
    subject: "جغرافيا",
    file_url: "#"
  },
  { 
    id: 8, 
    name: "ملخص الوحدة", 
    date: "2024-01-08", 
    size: "1.9 MB", 
    subject: "الدراسات الاجتماعية",
    file_url: "#"
  }
];

// Async thunk for fetching files by subject
export const fetchFilesBySubject = createAsyncThunk(
  "files/fetchFilesBySubject",
  async ({ subjectId = 0 } = {}, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      
      if (!token) {
        // Return static data if no token
        return {
          files: staticFiles,
          pagination: {
            total: staticFiles.length,
            per_page: 10,
            current_page: 1,
            last_page: 1,
            pages_count: 1
          }
        };
      }

      const response = await fetch(`${BASE_URL}/teacher_files/student_subject_files/${subjectId}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          files: staticFiles,
          pagination: {
            total: staticFiles.length,
            per_page: 10,
            current_page: 1,
            last_page: 1,
            pages_count: 1
          }
        };
      }

      // Handle the API response structure
      let filesData = [];
      let paginationData = {};

      if (data.result && data.result.data) {
        filesData = data.result.data;
        paginationData = data.result.pagination || {};
      } else if (data.result) {
        filesData = data.result;
        paginationData = data.pagination || {};
      } else {
        filesData = staticFiles;
        paginationData = {
          total: staticFiles.length,
          per_page: 10,
          current_page: 1,
          last_page: 1,
          pages_count: 1
        };
      }

      // Ensure pagination has both last_page and pages_count
      if (paginationData.last_page && !paginationData.pages_count) {
        paginationData.pages_count = paginationData.last_page;
      }
      if (paginationData.pages_count && !paginationData.last_page) {
        paginationData.last_page = paginationData.pages_count;
      }

      return {
        files: Array.isArray(filesData) ? filesData : staticFiles,
        pagination: paginationData
      };
    } catch (error) {
      console.error('Error fetching files:', error);
      return {
        files: staticFiles,
        pagination: {
          total: staticFiles.length,
          per_page: 10,
          current_page: 1,
          last_page: 1,
          pages_count: 1
        }
      };
    }
  }
);

const initialState = {
  files: [],
  loading: false,
  error: null,
  pagination: null,
  currentSubject: 0,
  currentPage: 1,
};

const filesSlice = createSlice({
  name: "files",
  initialState,
  reducers: {
    clearFilesError: (state) => {
      state.error = null;
    },
    setCurrentSubject: (state, action) => {
      state.currentSubject = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilesBySubject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFilesBySubject.fulfilled, (state, action) => {
        state.loading = false;
        state.files = action.payload.files;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchFilesBySubject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearFilesError, setCurrentSubject, setCurrentPage } = filesSlice.actions;
export default filesSlice.reducer; 